module.exports = __webpack_public_path__ + "img/RegisterImg.376552de.png";